export default "__VITE_ASSET__CLmNnhrk__"